export const UserReferralSource = Object.freeze({
    friends_or_family: 'friends_or_family',
    social_media: 'social_media',
    google_search: 'google_search',
    other: 'other',
    walked_by_a_game: 'walked_by_a_game',
    zog_sports: 'zog_sports',
});
const UserReferralSources = Object.freeze({
    zog_sports: { value: 'zog_sports', label: 'ZogSports' },
    friends_or_family: { value: 'friends_or_family', label: 'Friends or family' },
    social_media: { value: 'social_media', label: 'Social media' },
    google_search: { value: 'google_search', label: 'Google search' },
    walked_by_a_game: { value: 'walked_by_a_game', label: 'Walked by a game' },
    other: { value: 'other', label: 'Other' },
});
export const UserReferralSourceOptions = Object.freeze(Object.values(UserReferralSources));
